"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

require("core-js/stable");

var _loglevel = _interopRequireDefault(require("loglevel"));

require("regenerator-runtime/runtime");

/**
 * Session Service Client API
 *
 * Provides utility methods for making requests of the
 * {@link https://git.autodesk.com/dpe/dhx-ete-session dhx-ete-session} service.
 */
_loglevel.default.setLevel('ERROR');

var ENDPOINTS = {
  DEV: 'https://wwwutkp6h2.execute-api.us-east-1.amazonaws.com/DEV',
  STAGE: 'https://w8fijms7y1.execute-api.us-east-1.amazonaws.com/STAGE',
  PROD: 'https://udklrynjp5.execute-api.us-east-1.amazonaws.com/PROD'
};
var defaultEndpoints = {
  'dev': ENDPOINTS.DEV,
  'develop': ENDPOINTS.DEV,
  'development': ENDPOINTS.DEV,
  'stg': ENDPOINTS.STAGE,
  'stage': ENDPOINTS.STAGE,
  'staging': ENDPOINTS.STAGE,
  'prd': ENDPOINTS.PROD,
  'prod': ENDPOINTS.PROD,
  'production': ENDPOINTS.PROD
};

var SessionManager = /*#__PURE__*/function () {
  /** Default `dhx-ete-session` Endpoints */

  /** Client Application Identifier */

  /** Active `dhx-ete-session` service endpoint URL */

  /**
   * Create a new SessionService client.
   *
   * Please use a suitable client application identifier as your {@link origin} parameter
   * so that issues related to your specific use-cases can be identified for troubleshooting.
   *
   * The default (production) `dhx-ete-session` service endpoint URL can be overridden by
   * passing an alternate endpoint URL as the second parameter.
   *
   * @param origin Client Application Identifier
   * @param endpoint Alternate `dhx-ete-session` service endpoint. Can be one of 'prod' | 'stage' | 'dev' or a custom URL to be used as the service endpoint. Default: 'PROD'
   */
  function SessionManager(origin) {
    var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'PROD';
    (0, _classCallCheck2.default)(this, SessionManager);
    (0, _defineProperty2.default)(this, "origin", void 0);
    (0, _defineProperty2.default)(this, "sessionEndpoint", void 0);
    this.origin = origin;
    this.sessionEndpoint = defaultEndpoints[endpoint.toLowerCase()] || endpoint;

    _loglevel.default.debug("[@dhxete/util][SessionManager] Initializing new client with endpoint: ".concat(this.sessionEndpoint));
  }
  /**
   * Generate an initial signature.
   *
   * @remarks
   * You must obtain a `signature` tied to the same `requestId` before attempting
   * to use the {@link signIn} and {@link validateSignIn} methods.
   *
   * @param sessionId {String} Optional existing requestId (sessionId)
   * @returns The signature response object.
   */


  (0, _createClass2.default)(SessionManager, [{
    key: "generateSignature",
    value: function () {
      var _generateSignature = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(sessionId) {
        var response, _response$data, requestId, signature, clientId, accessId;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _loglevel.default.debug("[@dhxete/util][SessionManager] generateSignature(".concat(sessionId, ")"));

                _context.next = 3;
                return this.serviceRequest('generateSignature', sessionId);

              case 3:
                response = _context.sent;
                _response$data = response.data, requestId = _response$data.requestId, signature = _response$data.signature, clientId = _response$data.clientId, accessId = _response$data.accessId;
                return _context.abrupt("return", {
                  requestId: requestId,
                  signature: signature,
                  clientId: clientId,
                  accessId: accessId
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generateSignature(_x) {
        return _generateSignature.apply(this, arguments);
      }

      return generateSignature;
    }()
    /**
     * Begin a new authenticated session.
     *
     * @param requestId Pre-fetched request id (sessionId)
     * @param userId User id typically this is the user's oxygenId
     * @param signature Pre-fetched HMAC encoded signature
     * @returns Sign in response containing loggedIn: true|false
     */

  }, {
    key: "signIn",
    value: function () {
      var _signIn = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(requestId, userId, signature) {
        var _context2;

        var response, loggedIn;
        return _regenerator.default.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _loglevel.default.debug((0, _concat.default)(_context2 = "[@dhxete/util][SessionManager] signIn(".concat(requestId, ",")).call(_context2, userId, ")"));

                if (requestId && userId && signature) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('Invalid signIn request: requestId, userId, signature are all required.');

              case 3:
                _context3.next = 5;
                return this.serviceRequest('signIn', requestId, userId, signature);

              case 5:
                response = _context3.sent;
                loggedIn = response.data.loggedIn;
                return _context3.abrupt("return", {
                  loggedIn: loggedIn
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function signIn(_x2, _x3, _x4) {
        return _signIn.apply(this, arguments);
      }

      return signIn;
    }()
    /**
     * Terminate an existing authentication session.
     *
     * @param requestId Pre-fetched request id (sessionId)
     * @returns true if the session was successfully terminated.
     */

  }, {
    key: "signOut",
    value: function () {
      var _signOut = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(requestId) {
        var response, loggedOut;
        return _regenerator.default.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _loglevel.default.debug("[@dhxete/util][SessionManager] signOut(".concat(requestId, ")"));

                if (requestId) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", {
                  loggedOut: true
                });

              case 3:
                _context4.next = 5;
                return this.serviceRequest('signOut', requestId);

              case 5:
                response = _context4.sent;
                loggedOut = response.data.loggedOut;
                return _context4.abrupt("return", {
                  loggedOut: loggedOut
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this);
      }));

      function signOut(_x5) {
        return _signOut.apply(this, arguments);
      }

      return signOut;
    }()
    /**
     * Validate an existing authentication session.
     *
     * Use this method to establish the validity of an existing authentication session.
     *
     * @param requestId Pre-fetched request id (sessionId)
     * @param userId User id typically this is the user's oxygenId
     * @param signature Pre-fetched HMAC encoded signature
     * @returns Sign in response containing loggedIn: true|false
     */

  }, {
    key: "validateSignIn",
    value: function () {
      var _validateSignIn = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(requestId, userId, signature) {
        var _context5;

        var response, loggedIn;
        return _regenerator.default.wrap(function _callee4$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _loglevel.default.debug((0, _concat.default)(_context5 = "[@dhxete/util][SessionManager] validateSignIn(".concat(requestId, ",")).call(_context5, userId, ")"));

                if (requestId && userId && signature) {
                  _context6.next = 3;
                  break;
                }

                throw new Error('Invalid validateSignIn request: requestId, userId, signature are all required.');

              case 3:
                _context6.next = 5;
                return this.serviceRequest('validateSignIn', requestId, userId, signature);

              case 5:
                response = _context6.sent;
                loggedIn = response.data.loggedIn;
                return _context6.abrupt("return", {
                  loggedIn: loggedIn
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee4, this);
      }));

      function validateSignIn(_x6, _x7, _x8) {
        return _validateSignIn.apply(this, arguments);
      }

      return validateSignIn;
    }()
    /** @hidden */

  }, {
    key: "serviceRequest",
    value: function () {
      var _serviceRequest = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(type, requestId, userId, signature) {
        var headers, payload, res, response, _response$errors, _context8, _context9, messages;

        return _regenerator.default.wrap(function _callee5$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                headers = {
                  'Content-Type': 'application/json'
                };

                if (requestId) {
                  headers.Session = requestId;
                }

                payload = {
                  type: type,
                  origin: this.origin
                };
                _context10.t0 = type;
                _context10.next = _context10.t0 === 'signIn' ? 6 : _context10.t0 === 'validateSignIn' ? 6 : 9;
                break;

              case 6:
                headers.Authorization = signature;
                payload.oxygenId = userId;
                return _context10.abrupt("break", 9);

              case 9:
                _context10.prev = 9;
                _context10.next = 12;
                return _axios.default.post(this.sessionEndpoint, payload, {
                  headers: headers
                });

              case 12:
                res = _context10.sent;
                // console.log(`${type} Response`, res.data)
                response = res.data;

                if (!(response.status !== 200)) {
                  _context10.next = 17;
                  break;
                }

                messages = (_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : (0, _map.default)(_response$errors).call(_response$errors, function (err) {
                  var _context7;

                  return (0, _concat.default)(_context7 = "(".concat(err.code, ") ")).call(_context7, err.detail);
                }).join(' ');
                throw new Error((0, _concat.default)(_context8 = (0, _concat.default)(_context9 = "".concat(type, " service error: [")).call(_context9, response.status, "] ")).call(_context8, messages || 'Unknown Error'));

              case 17:
                _loglevel.default.debug('[@dhxete/util][SessionManager] Endpoint Response', response);

                return _context10.abrupt("return", response);

              case 21:
                _context10.prev = 21;
                _context10.t1 = _context10["catch"](9);

                _loglevel.default.error('[@dhxete/util][SessionManager] Endpoint Error', _context10.t1);

                throw _context10.t1;

              case 25:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee5, this, [[9, 21]]);
      }));

      function serviceRequest(_x9, _x10, _x11, _x12) {
        return _serviceRequest.apply(this, arguments);
      }

      return serviceRequest;
    }()
  }]);
  return SessionManager;
}();

exports.default = SessionManager;